<template>
  <div class="personnelManage">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.userAccount"
                  placeholder="输入用户账号"
                  @keyup.enter.native="handleSearch"
                  maxlength="30" size="medium" clearable
                  @input="e => searchForm.userAccount = validForbid(e)"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.userName"
                  placeholder="输入用户名称"
                  @keyup.enter.native="handleSearch"
                  maxlength="30" size="medium" clearable
                  @input="e => searchForm.userName = validForbid(e)"
          >
          </el-input>
        </el-form-item>

        <!-- <el-form-item>
            <el-input
                    v-model="searchForm.id"
                    placeholder="输入用户ID"
                    @keyup.enter.native="handleSearch"
                    maxlength="30" size="medium" clearable
                    @input="e => searchForm.id = validForbid(e)"
            >
            </el-input>
        </el-form-item> -->

      </template>
    </sr-filter>

    <!-- 主要内容-左边树+右边表格 -->
    <div class="mainBox boxs">
      <!-- 主要内容-左边 -->
      <div class="le_main boxs">
        <!-- tab切换-会员/角色 -->
        <ul class="tabBox clearfix">
          <li v-for="(item,index) in tabData.textArr" @click="tabLi(index)" :class="{on:tabData.nowIndex==index}">
            {{item}}
          </li>
        </ul>

        <!-- tab会员树 -->
        <div class="tabContent memberBox boxs" v-if="tabData.nowIndex == 0">
          <!-- :data="memberTreeData"  -->
          <el-tree
                  :props="memberTreeProps"
                  @node-click="handleMemberTreeClick"
                  highlight-current
                  lazy
                  :load="loadNode"
          >
          </el-tree>
        </div>

        <!-- tab角色列表 -->
        <div class="tabContent roleBox boxs" v-if="tabData.nowIndex == 1">
          <ul class="roleUlBox">
            <li v-for="(item,index) in roleData.roleArr" @click="changeRole(index, item.id)"
                :class="{on:roleData.roleIndex==index}">
              <i class="roleHead"></i>
              <span class="roleName">{{item.name}}</span>
            </li>
          </ul>
        </div>

      </div>

      <!-- 主要内容-右边表格 -->
      <div class="riTable tableTheadGray boxs">
        <div class="tableTop">
          <span class="leTableTit">人员列表</span>
          <div class="rightBox">
            <!-- 批量操作 -->
            <!-- <el-select class="batchSel" clearable v-model="batchValue" size="small" placeholder="批量操作" @change="batchOpt">
                <el-option
                    v-for="item in batchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select> -->
            <!-- <el-button class="orangeBtn" @click="batchComfirm()" :disabled="this.sels.length === 0 || this.batchValue === ''" size="small">确定</el-button> -->
            <!-- 添加人员按钮 -->
            <!-- <el-button @click="handleAddDialog()" class="greenBtn" icon="el-icon-plus" size="small">添加人员</el-button> -->
            <!-- 导出按钮 -->
            <!-- <el-button @click="tableExport()" class="orangeBtn" icon="el-icon-upload2" size="small">导出</el-button> -->
            <!-- <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                <i class="exportIcon"></i>
                <span>导出</span>
            </button> -->
          </div>
        </div>
        <el-table :data="tableData"
                  ref="multipleTable"
                  style="width: 100%;"
                  max-height="600"
                  border
                  fit
                  highlight-current-row
                  tooltip-effect="dark"
                  @selection-change="selsChange"
                  @row-click="handleTableChange"
        >
          <!-- 这是列表前面的多选框 -->
          <!-- <el-table-column type="selection" align="center" width="35"></el-table-column> -->

          <el-table-column label="人员账号" prop="ACCOUNT" min-width="150" header-align="center" align="center"
                           show-overflow-tooltip></el-table-column>

          <el-table-column label="人员姓名" prop="NAME" min-width="90" header-align="center" align="center"
                           show-overflow-tooltip></el-table-column>

          <el-table-column label="所属会员" prop="PARENT_MEMBER" min-width="124" header-align="center" align="center"
                           show-overflow-tooltip></el-table-column>

          <el-table-column label="角色" prop="GROUP_NAME" min-width="120" header-align="center" align="center"
                           show-overflow-tooltip></el-table-column>

          <!-- <el-table-column label="状态" prop="LOCK_STATUS" min-width="70" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.LOCK_STATUS" @change="statusChange(scope)" active-value="1"
                         inactive-value="2" active-color="#76C819" inactive-color="#dbdada"></el-switch>
            </template>
          </el-table-column> -->

          <el-table-column label="号码" prop="MOBILE_PHONE" width="130" header-align="center" align="center"
                           show-overflow-tooltip></el-table-column>

          <el-table-column label="操作" fixed="right" width="160" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="scope.row.ACCOUNT != 'admin'" @click="showEditDialog(scope)" class="greenText"
                         icon="fa fa-pencil" type="text" title="编辑"
              >编辑
              </el-button>
              <el-button v-if="scope.row.ACCOUNT != 'admin' && scope.row.LOCK_STATUS=='0'"
                         @click="showResetPasswordDialog(scope)"
                         class="greenText" icon="fa fa-lock" type="text" title="密码重置"
              >密码重置
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox boxs">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="searchForm.page" :page-sizes="[10, 20, 30]" :page-size="searchForm.rows"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

      </div>

    </div>


    <!-- 弹窗 -->
    <el-dialog width="460px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="80px">

        <el-row>
          <el-col :span="24">
            <el-form-item label="所属会员" prop="parent_id">
              <el-select v-if="dialogTitle == 'add'" v-model="postForm.parent_id" placeholder="请选择所属会员" filterable clearable>
                <el-option v-for="item in memberOptions" :key="item.id" :label="item.NAME" :value="item.id">
                </el-option>
              </el-select>

              <el-select v-if="dialogTitle == 'edit'" disabled v-model="postForm.parent_id" placeholder="请选择所属会员" filterable clearable>
                <el-option v-for="item in memberOptions" :key="item.id" :label="item.NAME" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="人员账号" prop="account">
              <el-input
                      v-model="postForm.account"
                      placeholder="请输入人员账号"
                      maxlength="30" clearable
                      @input="e => postForm.account = validForbid(e)"
                      v-if="dialogTitle == 'add'"
              >
              </el-input>
              <el-input
                      v-model="postForm.account"
                      placeholder="请输入人员账号"
                      maxlength="30" clearable
                      @input="e => postForm.account = validForbid(e)"
                      v-if="dialogTitle == 'edit'"
                      disabled
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="人员姓名" prop="name">
              <el-input
                      v-model="postForm.name"
                      placeholder="请输入人员姓名"
                      maxlength="10" clearable
                      @input="e => postForm.name = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号码" prop="mobile_phone">
              <el-input
                      v-model="postForm.mobile_phone"
                      placeholder="请输入手机号码"
                      maxlength="11" clearable
                      @input="e => postForm.mobile_phone = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="角色" prop="role">
              <el-select v-model="postForm.role" placeholder="请选择角色" multiple filterable clearable>
                <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="note">
              <el-input
                      v-model="postForm.note"
                      placeholder="请输入备注"
                      maxlength="180"
                      clearable
                      type="textarea"
                      :rows="3"
                      @input="e => postForm.note = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
                <!-- <el-button @click="beforeClose" type="warning" plain>取 消</el-button>
                <el-button @click="validateForm" type="warning">确 定</el-button> -->
                <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
                <button @click="validateForm" class="butStyle refuseOBtn">确 定</button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {objectToQueryString} from '@/utils/commonUtils.js';
  import {
    getMemberTreeReq, //获取会员树
    getPersonnelListReq, //人员管理表格数据
    statusChangeReq, //人员状态开关变化
    addPersonnelReq, //添加人员
    editPersonnelReq, //编辑人员
    getPersonnelDetailReq, //根据用户id获取用户信息
    getPersonnelRoleReq, //通过当前ID获取当前人员已选的角色
    resetPasswordReq, //人员密码重置
    getAllMemberReq, //返回所有会员信息
    getUserRoles,
  } from '@/api/System/personnelManage.js';
  import {
    getAllRoleDataReq, //获取所有角色
  } from '@/api/System/roleManage.js';
  import {setTimeout} from 'timers';


  // 弹窗的数据
  const defaultPostForm = {
    id: null, //用户id
    parent_id: null, //所属会员
    account: null, //人员账号
    name: null, //人员姓名
    mobile_phone: null, //手机号码
    role: [], //角色(用于获取表单的角色参数)
    rightBox: [], //角色(用于提交表单)
    note: null, //备注
  }

  // 搜索表格的条件-筛选栏
  const defaultSearchForm = {
    userAccount: '', //用户账号
    userName: '', //用户名称
    id: '', //用户ID
    page: 1, //当前页码
    rows: 10, //每页条数

    code: '', //角色编码

    parentId: '', //所属会员id
  }

  export default {
    name: "PersonnelManageIndex",
    data() {
      // 手机格式校验
      const validatePhone = (rule, value, callback) => {
        if (!value) {
          // 手机不能为空
          return callback(new Error('请输入手机号码'))
        }
        // 手机不为空时校验格式
        const phoneReg = /^[1][3,4,5,6,7,8][0-9]{9}$/
        if (phoneReg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机格式'))
        }
      }
      return {
        //标题
        topTitle: {
          title: '人员管理',
          subTit: ''
        },
        // 表格搜索条件
        searchForm: Object.assign({}, defaultSearchForm),

        // tab切换-会员/角色
        tabData: {
          textArr: ['会员', '角色'],
          nowIndex: 0
        },

        // 会员树数据
        memberTreeData: [],
        // 会员树数据格式
        memberTreeProps: {
          // children: 'children',
          label: 'name',
          labelId: 'id',
          isLeaf: 'temp'
        },
        // 角色数据
        roleData: {
          roleArr: [],
          roleIndex: null,
          roleId: null
        },

        // 表格数据
        tableData: [],
        // 表格已勾选数据
        checkedGouArrData: [],
        // 表格数据总数
        total: 0,
        // 表格勾选
        sels: [],
        // 批量选择下拉框
        batchOptions: [
          {label: '批量删除', value: 'del'},
        ],
        batchValue: '',

        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          add: '添加人员',
          edit: '编辑人员'
        },
        dialogTitle: '',
        // 所属会员
        memberOptions: [],
        // 角色
        roleOptions: [],
        // 弹窗校验规则
        rules: {
          parent_id: [{required: true, message: '请选择所属会员', trigger: 'blur'}],
          account: [{required: true, message: '请输入人员账号', trigger: 'blur'}],
          name: [{required: true, message: '请输入人员姓名', trigger: 'blur'}],
          mobile_phone: [{required: true, validator: validatePhone, trigger: 'blur'}],
          role: [{required: true, message: '请选择角色', trigger: 'blur'}],
        },
      }

    },
    components: {
      TitleBox,
      SrFilter
    },
    created() {
      // this.getmemberTreeData()
      // this.getAllRoleData()
      if (this.tabData.nowIndex == 0) { //会员
        this.getmemberTreeData()
      } else if (this.tabData.nowIndex == 1) { //角色
        this.getAllRoleData()
      }
      this.getPersonnelList()

    },
    methods: {
      // tab切换-会员/角色
      tabLi(nowIndex) {
        this.tabData.nowIndex = nowIndex;
        if (nowIndex == 0) { //会员

          this.getmemberTreeData()
          // 初始化角色参数
          this.searchForm.roleId = ''

        } else if (nowIndex == 1) { //角色

          this.getAllRoleData()
          // 初始化会员参数
          this.searchForm.parentId = ''
        }

        this.getPersonnelList()
      },
      // exportData导出表格数据
      tableExport() {
        var url = `${this.$baseUrl}/!org/user/~query/Q_USER_LIST.NEW?result=excel&${objectToQueryString(this.searchForm)}`;
        // console.log(url);
        window.open(url, '_blank');

        // window.open(`http://localhost:8080/esaleb-server/!org/user/~query/Q_USER_LIST.NEW?result=excel&${objectToQueryString(this.searchForm)}`, '_blank');
      },

      // 获取tab会员树数据
      getmemberTreeData() {
        // 会员树数据
        // getMemberTreeReq()
        //     .then(resp => {
        //         // if (resp.header && resp.header.code != 0) {
        //         //     this.$message.error(resp.header.message)
        //         //     return
        //         // }
        //         if (resp && resp.code != 0) {
        //             this.$message.error(resp.msg)
        //             return
        //         }
        //         // this.$message.success(msg)
        //         this.memberTreeData = resp.data
        //         this.memberTreeData.forEach(item =>{
        //             if(item.children.length <= 0) {
        //                 //该节点没有子节点 时，leaf为true
        //                 item.leaf = true
        //             }else if (item.children.length > 0) {
        //                 item.leaf = false
        //             }
        //         })
        //         console.log('this.memberTreeData22', this.memberTreeData)

        //     })
        //     .catch(e => {
        //         console.log(e);
        //     })
      },
      loadNode(node, resolve) {
        // console.log('node', node)
        // console.log('resolve', resolve)
        if (node.level === 0) { // node.level === 0 表示第一次进入页面
          // console.log('node.level === 0', '第一次进入页面')
          getMemberTreeReq()
              .then(resp => {
                if (resp && resp.code != 0) {
                  this.$message.error(resp.msg)
                  return
                }
                // this.$message.success(msg)
                this.memberTreeData = resp.data
                this.memberTreeData.forEach(item => {
                  if (item.temp == 'true') {
                    //该节点没有子节点 时，leaf为true
                    item.temp = true
                  } else if (item.temp == 'false') {
                    item.temp = false
                  }
                })
                // console.log('this.memberTreeData22', this.memberTreeData)
                resolve(this.memberTreeData);

              })
              .catch(e => {
                console.log(e);
                resolve([]);
              })
        } else if (node.level > 0) { //node.level > 0 表示点击树节点（不是第一次进入页面）
          // console.log('node.level > 0', '点击树节点')
          const params = {
            id: node.data.id
          }
          getMemberTreeReq(params)
              .then(resp => {
                if (resp && resp.code != 0) {
                  this.$message.error(resp.msg)
                  return
                }
                // this.$message.success(msg)
                let memberTreeDatas = resp.data
                memberTreeDatas.forEach(item => {
                  if (item.temp == 'true') {
                    //该节点没有子节点 时，leaf为true
                    item.temp = true
                  } else if (item.temp == 'false') {
                    item.temp = false
                  }
                })
                // console.log('memberTreeData33', memberTreeDatas)
                resolve(memberTreeDatas);

              })
              .catch(e => {
                console.log(e);
                resolve([]);
              })
        }
        ;
      },
      // 获取tab角色数据
      getAllRoleData() {
        getAllRoleDataReq()
            .then(resp => {
              if (resp && resp.code != 0) {
                this.$message.error(resp.msg)
                return
              }
              this.roleData.roleArr = resp.data
            })
            .catch(e => {
              console.log(e);
            })
      },
      // 会员树点击
      handleMemberTreeClick(data) {
        // console.log('MemberTreedata', data)
        this.searchForm.parentId = data.id
        this.getPersonnelList()
      },
      // 角色选择切换
      changeRole(index, roleId) {
        this.roleData.roleIndex = index;

        this.searchForm.roleId = roleId
        this.getPersonnelList()
      },


      // 获取人员管理表格数据
      async getPersonnelList() {

        getPersonnelListReq(this.searchForm)
            .then(resp => {
              if (resp && resp.code != 0) {
                this.$message.error(resp.msg)
                return
              }
              this.tableData = resp.data.records
              this.tableData.filter(item => {
                item.LOCK_STATUS = item.LOCK_STATUS.toString();
              })
              this.total = parseInt(resp.data.total)
            })
            .catch(e => {
              console.log(e);
            })
      },


      // 密码重置单个人员确认框
      showResetPasswordDialog(scope) {
        var resetParams = {
          id: scope.row.ID
        }
        var $this = this
        this.$confirm('您确定要重置密码为 888888？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          $this.resetPassword(resetParams, '密码重置成功！')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消密码重置操作'
          })
        })
      },
      // 密码重置
      resetPassword(Params, msg) {
        resetPasswordReq(Params)
            .then(resp => {
              if (resp && resp.code != 0) {
                this.$message.error(resp.msg)
                return
              }
              this.$message.success(msg)
              this.getPersonnelList()
            })
            .catch(e => {
              console.log(e);
            })
      },


      // 列表过滤查询
      handleSearch() {
        this.searchForm.page = 1
        this.getPersonnelList()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        this.searchForm = Object.assign({}, defaultSearchForm)
        // 获取表格数据
        this.getPersonnelList()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.rows = val
        this.getPersonnelList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.page = val
        this.getPersonnelList()
      },


      // 列表勾选
      selsChange(val) {
        this.sels = val
        // console.log('selsChange-val', val)
      },
      // 点击表格某一行
      handleTableChange(row, event, column) {
        // toggleRowSelection用于切换某一行的选中状态
        // this.$refs.multipleTable.toggleRowSelection(row)
        // console.log('handleTableChange-row', row)
        // console.log('handleTableChange-event', event)
        // console.log('handleTableChange-column', column)
      },
      // 批量处理
      batchOpt(value) {
        this.batchValue = value
      },
      // 批量处理确定按钮
      batchComfirm(value) {
        // if (this.batchValue == 'del') {
        //     for(var i=0; i<this.sels.length; i++){
        //         if (this.sels[i].status == '1') {
        //             this.$message.error('所选包含“启用”状态的人员，请重新选择！')
        //             return
        //         }
        //     }
        //     // 批量删除
        //     var idDelGroups = this.sels.map(item => item.id).join(",")
        //     var delParams = {
        //         ids: idDelGroups
        //     }
        //     var $this = this
        //         this.$confirm('删除人员将无法恢复，确定操作吗？', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         $this.delPersonnel(delParams, '批量删除成功！')
        //     }).catch(() => {
        //         this.$message({
        //             type: 'info',
        //             message: '已取消批量删除操作'
        //         })
        //     })

        // }

      },
      // 批量删除人员
      delPersonnel(ids, msg) {
        // delPersonnelReq(ids)
        //     .then(resp => {
        //         if (resp && resp.code != 0) {
        //             this.$message.error(resp.msg)
        //             return
        //         }
        //         this.$message.success(msg)
        //         this.getPersonnelList()
        //     })
        //     .catch(e => {
        //         console.log(e);
        //     })
      },


      // 人员状态开关变化
      statusChange(scope) {
        console.log('scope.row', scope.row)
        const statusParams = {
          id: scope.row.ID,
          // lock_status: 1启用，2禁用
        }
        let finalMsg;
        // 变成1==启用事件
        if (scope.row.LOCK_STATUS == '1') {
          statusParams.lock_status = '1' //启用
          finalMsg = '启用成功'
        } else if (scope.row.LOCK_STATUS == '2') { // 变成2==注销事件
          statusParams.lock_status = '2' //禁用
          finalMsg = '注销成功'
        }
        // 发送请求
        statusChangeReq(statusParams)
            .then(resp => {
              if (resp && resp.code != 0) {
                this.$message.error(resp.msg)
                return
              }
              this.$message.success(finalMsg)
              this.getPersonnelList()
            })
            .catch(e => {
              console.log(e);
            })
      },


      // 会员下拉框
      initMemberOption() {

        getAllMemberReq().then(resp => {
          this.memberOptions = resp.data
        }).catch(err => {
          console.log(err)
        })
      },
      // 角色下拉框
      initRoleOption() {
        const params = {
          id: ''
        }
        // getAllRoleDataReq().then(resp => {
        getPersonnelRoleReq(params).then(resp => {
          this.roleOptions = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      // 弹出“添加人员”窗口
      handleAddDialog() {
        this.dialogTitle = 'add'
        this.dialogFormVisible = true
        this.initMemberOption()
        this.initRoleOption()
        // console.log('弹出添加窗口-this.postForm', this.postForm)
      },
      // 弹出“编辑人员”窗口
      showEditDialog(data) {
        this.dialogTitle = 'edit'
        this.dialogFormVisible = true

        const rowDate = JSON.parse(JSON.stringify(data.row))
        this.initMemberOption()
        this.initRoleOption()

        const params = {
          id: rowDate.ID
        }
        this.postForm.id = rowDate.ID
        // 通过当前ID请求更多的数据
        this.getPersonnelDetail(params)
        // 通过当前ID获取当前人员已选的角色
        this.getPersonnelRole(params.id)

        // this.$nextTick(() => {
        // })

        // setTimeout(() => {
        //     this.dialogFormVisible = true
        // }, 1000);

      },
      // 获取指定会员信息(编辑弹窗回显)
      getPersonnelDetail(params) {

        getPersonnelDetailReq(params).then(resp => {
          if (resp && resp.code != 0) {
            this.$message.error(resp.msg)
            return
          }
          const pDetail = resp.data

          this.postForm.parent_id = pDetail.parent_id
          // this.postForm.parent_name = pDetail.parent_name
          this.postForm.account = pDetail.account
          this.postForm.name = pDetail.NAME
          this.postForm.mobile_phone = pDetail.MOBILE_PHONE
          // this.postForm.note = pDetail.note

        }).catch(err => {
          console.log(err)
        })
      },
      // 通过当前ID获取当前人员已选的角色(编辑弹窗回显)
      getPersonnelRole(userId) {
          getUserRoles(userId).then(resp => {
          const respArr = resp.data
          // console.log('respArr', respArr)
          console.log('respArr', respArr)
          // 先找出“1”的数据：用户是否属于该角色（0不属于 ，1属于）
          const roleDetail = []
          var j = 0;
          for (let i in respArr) {
            // if (respArr[i].checked == '1') {
              roleDetail[j++] = respArr[i]
            // }
          }
          const roleGroups = roleDetail.map(item => item.roleId)

              console.log('roleGroups', roleGroups)
          this.postForm.role = roleGroups

        }).catch(err => {
          console.log(err)
        })
      },

      // 弹窗关闭前
      beforeClose() {
        console.log(this.postForm)
        this.resetData()
      },
      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
        // this.postForm.role = null
        // this.postForm.rightBox = []
        // console.log(this.postForm)
        // console.log('弹窗关闭前resetData-this.postForm', this.postForm)
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitForm()
          } else {
            this.dialogFormVisible = true
          }
        })
      },
      // 提交表单
      async submitForm() {
        // console.log('this.postForm11', this.postForm)

        if (this.dialogTitle === 'add') {
          if (this.postForm.role.length > 0) {
            var roleArr = this.postForm.role
            var codeAuthGroups = roleArr.map(item => ({code: item}))
            this.postForm.rightBox = codeAuthGroups
            this.postForm.password = '888888'; // 密码
          }

          this.addPersonnel()
        } else if (this.dialogTitle === 'edit') {
          if (this.postForm.role.length > 0) {
            var roleArr = this.postForm.role
            var codeAuthGroups = roleArr.map(item => ({code: item}))
            this.postForm.rightBox = codeAuthGroups
          }

          this.editPersonnel()
        }
      },

      // 添加人员
      addPersonnel() {
        // const timeStamp = new Date().getTime();
        // this.postForm.t = timeStamp.toString();
        const editParams = this.postForm;
        addPersonnelReq(editParams).then(resp => {
          if (resp && resp.code != 0) {
            this.$message.error(resp.msg)
            return
          }
          this.$message.success('添加人员成功')
          this.closeDialog()
          this.getPersonnelList()
        }).catch(err => {
          console.log(err)
        })
      },
      // 编辑人员
      editPersonnel() {
        // const timeStamp = new Date().getTime();
        // this.postForm.t = timeStamp.toString();
        const editParams = this.postForm;
        editPersonnelReq(editParams).then(resp => {
          if (resp && resp.code != 0) {
            this.$message.error(resp.msg)
            return
          }
          this.$message.success('编辑人员成功')
          this.closeDialog()
          this.getPersonnelList()
        }).catch(err => {
          console.log(err)
        })
      },


    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  // 批量操作
  .batchSel {
    width: 130px;
    margin-right: 5px;
  }

  .orangeBtn {
    color: #FFFFFF !important;
    background-color: #FA6241;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 按钮
  .el-button {
  }

  .greenBtn {
    color: #FFFFFF !important;
    background-color: #2DBAA5;

    &:hover {
      background-color: rgb(115, 196, 183);
    }
  }


  .personnelManage {
    min-width: 1080px;
    height: 100%;
  }

  // 筛选框
  .personnelManage .searchBox {
    margin-top: 1px;
  }

  // 主要内容
  .personnelManage .mainBox {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  // 主要内容-左边
  .mainBox .le_main {
    width: 312px;
    min-width: 312px;
    min-height: 616px;
    height: 100%;
    background: #ffffff;
    padding: 12px 9px 8px 4px;
    display: flex;
    flex-flow: column nowrap;
  }

  .mainBox .le_main .tabBox {
    width: 100%;
    height: 20px;
    line-height: 20px;
    background: #fff;
    text-align: center;
  }

  .tabBox li {
    display: inline-block;
    width: 40px;
    color: #7F7F7F;
    font-size: 13px;
    cursor: pointer;
    position: relative;
  }

  .tabBox li + li {
    margin-left: 20px;
  }

  .tabBox li.on {
    color: #FA6241;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    width: 40px;
    height: 3px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabBox li.on:after {
    background: #FA6241;
  }

  .mainBox .le_main .tabContent {
    margin-top: 20px;
    width: 100%;
    min-height: 580px;
    max-height: 600px;
    background: #F5F5F5;
    border-radius: 3px;
  }

  .mainBox .le_main .tabContent.memberBox {
    padding-top: 12px;
    overflow-y: auto;
    overflow-x: auto;
  }

  .mainBox .le_main .tabContent.roleBox {
    padding-top: 8px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
  }

  .roleBox .roleUlBox {
    width: 100%;
    height: 100%;
  }

  .roleBox .roleUlBox li {
    width: 100%;
    height: 24px;
    line-height: 24px;
    padding-left: 11px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .roleBox .roleUlBox li.on {
    background: #FAFAFA;
  }

  .roleBox .roleUlBox li + li {
    margin-top: 2px;
  }

  .roleBox .roleUlBox li i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOff.png') no-repeat;
    background-size: 100% 100%;
  }

  .roleBox .roleUlBox li.on i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOn.png') no-repeat;
    background-size: 100% 100%;
  }

  .roleBox .roleUlBox li span.roleName {
    width: calc(100% - 16px - 4px);
    margin-left: 4px;
    height: 16px;
    line-height: 16px;
    color: #4E4A46;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .roleBox .roleUlBox li.on span.roleName {
    color: #FA6241;
  }


  // 主要内容-右边
  .mainBox .riTable {
    width: calc(100% - 312px - 12px);
    min-width: 600px;
    height: auto;
    margin-left: 12px;
  }

  .riTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .riTable .tableTop .leTableTit {
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .riTable .tableTop .rightBox {
    width: auto;
    min-width: 200px; //考虑是否删去
    text-align: right;
    display: inline-block;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }

  .riTable .tableTop .addBtn {
    width: 98px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(134, 189, 180)
    }
  }

  .riTable .tableTop .addBtn .addIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  .riTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .riTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }


  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

</style>
